// The stage an address asks the review to open on: `?stage=opening|middlegame|ending`
// (2026-10-13), set by the library's game rows when the library was reached
// from a stage screen (the games API's STAGE_PARAM). Read once per game, when
// the game is in; a `#ply=` in the same address wins over the stage's first
// position, the tab still follows. Pure, tested.
import type { Phase } from '@chess/api-model';
import { isPhase } from './tab-click.ts';

export function requestedStage(search: string): Phase | undefined {
  const raw = new URLSearchParams(search).get('stage') ?? '';
  return isPhase(raw) ? raw : undefined;
}

/** Whether the address names a position of its own, which the stage's first position must not override. */
export function hasPly(hash: string): boolean {
  return /(^#|[#&?])ply=\d+/.test(hash);
}
